<div class="master-card shadow-sm p-4 rounded bg-white">
    <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
            <h3 class="m-0 fw-bold text-dark">Master Users</h3>
            <p class="text-muted small m-0">View all users for a specific client</p>
        </div>
        <div class="d-flex gap-2 align-items-center">
            <div class="btn-group btn-group-sm">
                <button 
                    *ngFor="let type of projectTypes" 
                    type="button" 
                    class="btn" 
                    [class.btn-primary]="selectedClient === type.value"
                    [class.btn-outline-secondary]="selectedClient !== type.value"
                    (click)="switchClient(type.value)">
                    {{ type.label }}
                </button>
            </div>
            <button class="btn btn-outline-secondary btn-sm rounded-0" (click)="loadUsers()">
                <i class="pi pi-refresh"></i>
            </button>
        </div>
    </div>

    <p-table 
        [value]="users" 
        [loading]="loading" 
        [rows]="10" 
        [paginator]="true" 
        responsiveLayout="scroll"
        styleClass="p-datatable-sm p-datatable-striped">
        <ng-template pTemplate="header">
            <tr>
                <th>Username</th>
                <th>Email</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Status</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user>
            <tr>
                <td class="fw-medium">{{ user.username }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.firstName }}</td>
                <td>{{ user.lastName }}</td>
                <td>
                    <p-tag 
                        [severity]="user.enabled ? 'success' : 'danger'" 
                        [value]="user.enabled ? 'Enabled' : 'Disabled'">
                    </p-tag>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5" class="text-center py-4 text-muted">No users found for {{ selectedClient }}.</td>
            </tr>
        </ng-template>
    </p-table>
</div>
<p-toast></p-toast>
